import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'smm-input-error',
  imports: [TranslatePipe],
  template: `@for (err of listOfErrors(); track $index) {
    <small class="text-red-200">
      @if (control()) {
        {{ err | translate }}
      } @else {
        {{ err | translate }}
      }
    </small>
  } `,
  styles: [
    `
      .text-red-200 {
        color: red;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputError {
  control = input<AbstractControl>();
  customeErrorMsg = input('');
  minlength = input(1);
  digitNumber = input(1);
  upperCase = input(1);
  lowerCase = input(1);
  specialChar = input(1);
  parentTranslate = 'ERRORS.';

  get ERROR_MESSAGE_KEYS(): { [key: string]: string } {
    return {
      required: this.parentTranslate + `REQUIRED`,
      email: this.parentTranslate + 'INVALID_EMAIL',
      notEmail: this.parentTranslate + 'INVALID_EMAIL',
      personalEmail: this.parentTranslate + 'BUSINESS_EMAIL',
      notPhone: this.parentTranslate + 'INVALID_PHONE',
      maxlength: this.parentTranslate + 'MAX_LENGTH',
      minlength: this.parentTranslate + 'MIN_LENGTH',
      pattern: this.parentTranslate + 'INVALID_PATTERN',
      invalid: this.parentTranslate + 'INVALID',
      passwordMismatch: this.parentTranslate + 'PASSWORD_MISMATCH',
      weakPassword: this.parentTranslate + 'WEAK_PASSWORD',
    };
  }
  listOfErrors(): string[] {
    const control = this.control();
    if (!control?.errors) {
      return [];
    }

    return Object.keys(control.errors).map(
      (err) => this.ERROR_MESSAGE_KEYS[err] || this.parentTranslate + 'UNKNOWN',
    );
  }
}
